import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-plus-icon',
  templateUrl: './circle-plus-icon.component.html'
})
export class CirclePlusIconComponent {
}
